import { createContext } from "react";

export const BudgetTrackingStoreContext = createContext(null);
